const SunIcon = ({ x, y, size }) => (
  <svg
    x={x}
    y={y}
    width={size}
    height={size}
    viewBox="0 0 800 800"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      cx="400"
      cy="400"
      r="166.667"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M400,148.333c-8.284,0-15-6.716-15-15V66.667c0-8.284,6.716-15,15-15s15,6.716,15,15v66.667
        C415,141.618,408.284,148.333,400,148.333z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M400,748.333c-8.284,0-15-6.716-15-15v-66.666c0-8.284,6.716-15,15-15s15,6.716,15,15v66.666
        C415,741.617,408.284,748.333,400,748.333z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M133.333,415H66.667c-8.284,0-15-6.716-15-15s6.716-15,15-15h66.667c8.284,0,15,6.716,15,15
        S141.618,415,133.333,415z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M733.333,415h-66.666c-8.284,0-15-6.716-15-15s6.716-15,15-15h66.666c8.284,0,15,6.716,15,15
        S741.617,415,733.333,415z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M585.197,223.475c-4.064,0-8.115-1.642-11.074-4.878c-5.59-6.114-5.165-15.602,0.948-21.192l74.066-67.719
        c6.114-5.59,15.603-5.165,21.192,0.949c5.59,6.114,5.165,15.602-0.948,21.192l-74.066,67.719
        C592.438,222.176,588.812,223.475,585.197,223.475z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M214.802,223.475c-3.614,0-7.239-1.298-10.117-3.93l-74.067-67.719c-6.114-5.59-6.539-15.078-0.949-21.192
        c5.588-6.115,15.077-6.54,21.192-0.949l74.067,67.719c6.114,5.59,6.539,15.078,0.949,21.192
        C222.918,221.833,218.867,223.475,214.802,223.475z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M140.737,674.264c-3.839,0-7.677-1.464-10.607-4.394c-5.857-5.857-5.857-15.355,0-21.213l74.075-74.073
        c5.858-5.858,15.354-5.858,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-74.075,74.073
        C148.415,672.799,144.575,674.264,140.737,674.264z"
    />
    <path
      fill="#FFCD33"
      stroke="#fff"
      strokeWidth="2"
      d="M659.26,674.243c-3.839,0-7.678-1.465-10.607-4.394l-74.066-74.073c-5.857-5.858-5.856-15.355,0.001-21.214
        c5.857-5.856,15.354-5.855,21.214,0.001l74.066,74.073c5.857,5.858,5.856,15.355-0.001,21.214
        C666.938,672.778,663.098,674.243,659.26,674.243z"
    />
  </svg>
);

export default SunIcon;
